import { InputHTMLAttributes, ReactNode, Ref, useId } from 'react';

import { Styles, css, cx } from '@flipster/styled-system/css';
import { checkedInput } from '@flipster/styled-system/recipes';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'title' | 'type' | 'className'> {
  ref?: Ref<HTMLInputElement>;
  children?: ReactNode;
  css?: Styles;
}

export const Checkbox = ({ ref, children, css: cssProps, ...inputRef }: Props) => {
  const labelId = useId();
  const classes = checkedInput();

  return (
    <label data-disabled={inputRef.disabled} className={cx(classes.control, css(cssProps))}>
      <input type='checkbox' {...inputRef} ref={ref} className={classes.input} />
      <div className={classes.action_wrapper}>
        <span role='checkbox' aria-checked={inputRef.checked} aria-labelledby={labelId} className={classes.checkbox}>
          <svg width='12' height='12' viewBox='0 0 12 12' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M10.2354 1.89696C10.6374 2.16502 10.7461 2.70828 10.478 3.11036L5.97804 9.86036C5.83263 10.0785 5.59709 10.2199 5.33622 10.2457C5.07535 10.2716 4.81665 10.1791 4.63128 9.99372L1.63128 6.99372C1.28957 6.65201 1.28957 6.09799 1.63128 5.75628C1.97299 5.41457 2.52701 5.41457 2.86872 5.75628L5.114 8.00157L9.02196 2.13964C9.29001 1.73755 9.83327 1.6289 10.2354 1.89696Z'
            />
          </svg>
        </span>
        <wbr />
      </div>

      <span id={labelId} className={classes.label}>
        {children}
      </span>
    </label>
  );
};
